import { Observable } from 'rxjs';
import { ofType } from 'redux-observable';
import { mergeMap } from 'rxjs/operators';
import * as artists from '@webapp/sdk/artists';
import { Action } from 'redux';
import {
  UpdateArtistsPlatforms,
  UpdateArtistsPlatformsError,
  UpdateArtistsPlatformsSuccess,
} from '../action-creators';
import { UPDATE_ARTISTS_PLATFORMS } from '../actions';

export const updateArtistPlatformsEpic = (action$: Observable<Action>) =>
  action$.pipe(
    ofType<Action, UpdateArtistsPlatforms>(UPDATE_ARTISTS_PLATFORMS),
    mergeMap(async (action) => {
      try {
        await Promise.all(
          action.artists.map((artist) =>
            artists.updatePlatforms(artist.id, artist.platforms)
          )
        );

        return new UpdateArtistsPlatformsSuccess(
          action.artists,
          action.ownerId,
          action.releaseId
        );
      } catch (err) {
        return new UpdateArtistsPlatformsError(err.message);
      }
    })
  );
